import React from 'react';
import ReactDOM from 'react-dom';
import packageJson from '../package.json';
import App from './App';
import './index.css';
import { Provider } from "react-redux";
import store from "./Store";
import './Fonts/AlexBrush/AlexBrush-Regular.ttf';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from '../src/DocPlace/Login/authConfig';

const appName = process.env.REACT_APP_NAME || 'DocPlace';
const appVersion = process.env.REACT_APP_VERSION || packageJson.version;
document.title = `${appName} - v${appVersion}`;

const msalInstance = new PublicClientApplication(msalConfig);

// Define a render function
const renderApp = () => {
  const app = (
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </Provider>
  );

  ReactDOM.render(app, document.getElementById("root"));
};

// Await MSAL initialization before rendering
msalInstance.initialize()
  .then(() => {
    if (window.location.hash !== '') {
      console.log("hash found: " + window.location.hash);
    }

    renderApp();
  })
  .catch((error) => {
    console.error("MSAL initialization failed:", error);
  });
